import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M182.2 146.7h-7.4V53.3h7.4c4.1 0 7.4-3.4 7.4-7.5V17.5c0-4.1-3.3-7.5-7.4-7.5h-29.6c-4.1 0-7.4 3.4-7.4 7.5v6.7H54.4v-6.7c0-4.1-3.3-7.5-7.4-7.5H17.4c-4.1 0-7.4 3.4-7.4 7.5v28.8c0 4.1 3.3 7.5 7.4 7.5h7.4v92.6h-7.4c-4.1 0-7.4 3.4-7.4 7.5v28.4c0 4.1 3.3 7.5 7.4 7.5H47c4.1 0 7.4-3.4 7.4-7.5v-6.7h91.3v7.1c0 4.1 3.3 7.5 7.4 7.5h29.6c4.1 0 7.4-3.4 7.4-7.5v-28.8c-.5-4.2-3.8-7.2-7.9-7.2zm-22.1 0h-7.4c-1.1 0-1.8.4-3 .7l10.3-10.5v9.8zm-105.7 6c-.4-3.7-3.7-6.3-7.4-6.3l97.9-99c.4 3.7 3.7 6.3 7.4 6.3l-97.9 99zm0-113.6h8.9L54 48.5c.4-.7.4-1.5.4-2.2v-7.2zM39.6 53.3H47c.7 0 1.5 0 2.2-.4l-9.6 9.7v-9.3zm0 30.6L84 39.1h13.7l-58 58.6V83.9zm79.1-44.8h13.7L40 132.5v-13.8l78.7-79.6zM67.3 160.5l92.4-93.4V81L81 160.5H67.3zm34.7 0 58-58.6v13.8l-44.4 44.8H102zm43.6-9.3c-.4.7-.7 1.9-.7 3v6.7H136l9.6-9.7z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}